import { UrlSegment } from '@angular/router';

export interface IStep {
  stepId?: string;
  anchorId?: string;
  title?: string;
  content?: string;
  route?: string | UrlSegment[];
  nextStep?: number | string;
  prevStep?: number | string;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
  preventScrolling?: boolean;
  containerClass?: string;
  orphan?: boolean;
  promise?: Promise<any>;
  delay?: number;
  backdrop?: boolean;
}
export type TourState = number;
export let TourState: any = {};
TourState.OFF = 0;
TourState.ON = 1;
TourState.PAUSED = 2;
TourState[TourState.OFF] = "OFF";
TourState[TourState.ON] = "ON";
TourState[TourState.PAUSED] = "PAUSED";

